

import lodash from "lodash"
import EasyFormater from "@/utils/easy_formater"

var LegsStatReader = {

  get_source: function(stat){
    if(stat.gameId){
      return "riot"
    }else if(stat.gameInfo){
      return "tencent"
    }else{
      return
    }
  },
  get_game_id: function(stat){

    var source = this.get_source(stat)

    if(source == "riot"){
      return stat.gameId
    }else{
      return stat.gameInfo.gameId
    }
  },
  get_game_mode: function(stat){

    var source = this.get_source(stat)

    if(source == "riot"){
      return stat.gameMode
    }else{
      return stat.gameInfo.gameMode
    }
  },
  get_game_version: function(stat){

    var source = this.get_source(stat)

    if(source == "riot"){
      return stat.gameVersion
    }else{
      return stat.gameInfo.gameVersion
    }
  },
  get_game_name: function(stat){

    var source = this.get_source(stat)

    if(source == "riot"){
      return ""
    }else{
      return stat.gameInfo.gameName
    }
  },
  get_game_server_name: function(stat){

    var source = this.get_source(stat)

    if(source == "riot"){
      return ""
    }else{
      return stat.gameInfo.gameServerName
    }
  },
  get_game_start_time: function(stat){

    var source = this.get_source(stat)

    if(source == "riot"){
      return new Date(stat.gameCreation)
    }else{
      return new Date(stat.gameInfo.gameStartTimestamp)
    }
  },
  get_game_end_time: function(stat){

    var source = this.get_source(stat)

    if(source == "riot"){
      return new Date(stat.gameCreation + stat.gameDuration * 1000)
    }else{
      return new Date(stat.gameStats.finalFrameTimestamp)
    }
  },
  get_game_duration: function(stat){

    var startTime = this.get_game_start_time(stat)
    var endTime = this.get_game_end_time(stat)

    if(endTime > startTime){
      return (endTime - startTime) / 1000
    }else{
      return 0
    }
  },
  format_game_duration: function(stat){

    var gameDuration = this.get_game_duration(stat)

    return EasyFormater.format_duration(gameDuration)
  },
  format_game_start_time: function(stat){
    var startTime = this.get_game_start_time(stat)
    return EasyFormater.format_date_time(startTime)
  },
  format_game_end_time: function(stat){
    var endTime = this.get_game_start_time(stat)
    return EasyFormater.format_date_time(endTime)
  },
  get_game_players: function(stat){

    var source = this.get_source(stat)

    var players = []

    var hitNames = {}
    if(source == "riot"){
      lodash.each(stat.participantIdentities, function(identity){
        hitNames[identity.participantId] = identity.player.summonerName
      })
    }
      
    lodash.each(stat.participants, function(participant){

      var playerName
      var originalAccountId
      if(source == "riot"){
        playerName = hitNames[participant.participantId]
        originalAccountId = participant.participantId
      }else{
        playerName = participant.summonerName
        originalAccountId = participant.originalAccountId
      }

      var partStat = participant.stats

      var player = {
        teamId: participant.teamId,
        championId: participant.championId,
        summonerName: playerName,
        participantId: participant.participantId,
        originalAccountId: originalAccountId,
        assists: partStat.assists,
        champLevel: partStat.champLevel,
        deaths: partStat.deaths,
        kills: partStat.kills,
        totalDamageDealtToChampions: partStat.totalDamageDealtToChampions,
        totalDamageTaken: partStat.totalDamageTaken
      }
      players.push(player)
    })

    var sortPlayers = lodash.sortBy(players, ["teamId", "participantId"])

    return sortPlayers
  }
}

export default LegsStatReader